export default __webpack_public_path__ + "static/media/close.244b6687.svg";